module.exports = __webpack_public_path__ + "public/img/消防设置Bg.2ae39963.png";